import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "bg-white border p-4 rounded-lg shadow-lg flex flex-col gap-1 font-normal w-[600px]" }
const _hoisted_2 = {
  key: 0,
  class: "flex gap-2 flex-wrap mb-1"
}
const _hoisted_3 = { class: "font-semibold text-base" }
const _hoisted_4 = {
  key: 1,
  class: "flex flex-col text-sm"
}
const _hoisted_5 = { class: "oaiCriticalPathGraphNodeHoverItem border-b" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_7 = {
  class: "text-white rounded-lg px-2 py-0.5 truncate w-min max-w-full",
  style: { backgroundColor: '#bccfcc' }
}
const _hoisted_8 = { class: "text-white rounded-lg px-2 py-0.5 truncate w-min bg-green max-w-full" }
const _hoisted_9 = {
  key: 0,
  class: "oaiCriticalPathGraphNodeHoverItem border-t font-semibold"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "py-0.5" }, null, -1)
const _hoisted_11 = { class: "py-0.5" }
const _hoisted_12 = { class: "py-0.5" }
const _hoisted_13 = { class: "mt-6 flex flex-col gap-1 text-xs" }
const _hoisted_14 = { class: "flex gap-1 items-center" }
const _hoisted_15 = { class: "w-[100px] truncate" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "w-[10px]" }, null, -1)
const _hoisted_18 = { class: "w-[50px] text-right truncate" }
const _hoisted_19 = {
  class: "text-white rounded-lg px-2 py-0.5 ml-1 truncate w-min capitalize",
  style: { backgroundColor: '#bccfcc' }
}
const _hoisted_20 = {
  key: 0,
  class: "flex gap-1 items-center"
}
const _hoisted_21 = { class: "w-[100px] truncate" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "w-[10px]" }, "-", -1)
const _hoisted_23 = { class: "w-[50px] text-right truncate" }
const _hoisted_24 = { class: "text-white rounded-lg px-2 py-0.5 ml-1 truncate w-min bg-green capitalize" }
const _hoisted_25 = {
  key: 1,
  class: "flex gap-1 items-center"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "w-[100px] truncate" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "w-[10px]" }, null, -1)
const _hoisted_28 = { class: "w-[50px] text-right border-t pt-1 truncate" }

import { format } from "date-fns";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useHasPermission } from "shared/composables/project";
import {
  CriticalPathNodeEx,
  CriticalPathContext,
  CriticalPathDelta,
  CriticalPathEx,
  CriticalPathTag,
} from "shared/types/CriticalPath";
import {
  useCriticalPathTagLetterById,
  useDeltaTextWithBackgroundClass,
  useFormattedDelta,
} from "../composables";
import CriticalPathGraphNodeHoverItem from "./CriticalPathGraphNodeHoverItem.vue";
import CriticalPathGraphNodeHoverNotFinishedSummary from "./CriticalPathGraphNodeHoverNotFinishedSummary.vue";
import "./criticalPath.css";

const dateFormat = "dd.MM.yyyy";


export default /*#__PURE__*/_defineComponent({
  __name: 'CriticalPathGraphNodeHover',
  props: {
    criticalPath: {},
    criticalPathNode: {},
    context: {},
    deltaForNode: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();

const isAdmin = useHasPermission(["app_admin", "pct_admin"]);

const criticalPathTagLetterById = useCriticalPathTagLetterById(computed(() => props.criticalPath));

const componentSourceIds = computed(() => {
  const { plannedEventsBySourceId, actualEventsBySourceId } = props.context;
  const result = props.criticalPathNode.component_source_ids.slice();
  result.sort((a, b) => {
    const plannedA = plannedEventsBySourceId[a]?.end.getTime() || 0;
    const plannedB = plannedEventsBySourceId[b]?.end.getTime() || 0;
    if (plannedA === plannedB) {
      const actualA = actualEventsBySourceId[a]?.end?.getTime() || Infinity;
      const actualB = actualEventsBySourceId[b]?.end?.getTime() || Infinity;
      return actualA - actualB;
    }
    return plannedA - plannedB;
  });
  return result;
});

const delta = computed(() => props.deltaForNode.workingDays);
const differenceWithBackgroundClass = useDeltaTextWithBackgroundClass(delta);
const formattedDelta = useFormattedDelta(delta);

const criticalPathTagsById = computed(() =>
  props.criticalPath.tags.reduce((acc, tag) => {
    acc[tag._id] = tag;
    return acc;
  }, {} as Record<string, CriticalPathTag>),
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.criticalPathNode.tags.length > 0 && _unref(isAdmin))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.criticalPathNode.tags, (tagId) => {
            return (_openBlock(), _createElementBlock("div", {
              key: tagId,
              class: "bg-gray-400 text-white px-2 py-0.5 rounded text-xs truncate"
            }, " [" + _toDisplayString(_unref(criticalPathTagLetterById)[tagId]) + "] " + _toDisplayString(criticalPathTagsById.value[tagId]?.name), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.criticalPathNode.full_name), 1),
    (componentSourceIds.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)("analytics.critical_path.planned_end")), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)("analytics.critical_path.actual_end")), 1),
            _createElementVNode("div", null, _toDisplayString(_unref(t)("analytics.critical_path.working_days")), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(componentSourceIds.value, (sourceId) => {
            return (_openBlock(), _createBlock(CriticalPathGraphNodeHoverItem, {
              key: sourceId,
              sourceId: sourceId,
              criticalPathNode: _ctx.criticalPathNode,
              context: _ctx.context,
              deltaForNode: _ctx.deltaForNode
            }, null, 8, ["sourceId", "criticalPathNode", "context", "deltaForNode"]))
          }), 128)),
          (
          _ctx.criticalPathNode.state === 'finished' &&
          _ctx.deltaForNode.plannedEvent &&
          _ctx.deltaForNode.actualEvent?.end &&
          _ctx.deltaForNode.workingDays !== null &&
          _ctx.context.plannedEventsBySourceId[_ctx.deltaForNode.actualEvent.source_id]?._id !==
            _ctx.deltaForNode.plannedEvent?._id
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(format)(_ctx.deltaForNode.plannedEvent.end, dateFormat)), 1),
                _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(format)(_ctx.deltaForNode.actualEvent.end, dateFormat)), 1),
                _createElementVNode("div", {
                  class: _normalizeClass(["w-min rounded-full px-2 py-0.5 whitespace-nowrap", _unref(differenceWithBackgroundClass)])
                }, _toDisplayString(_unref(formattedDelta)), 3)
              ]))
            : _createCommentVNode("", true),
          (_ctx.criticalPathNode.state !== 'finished')
            ? (_openBlock(), _createBlock(CriticalPathGraphNodeHoverNotFinishedSummary, {
                key: 1,
                criticalPathNode: _ctx.criticalPathNode,
                deltaForNode: _ctx.deltaForNode,
                class: "mt-6"
              }, null, 8, ["criticalPathNode", "deltaForNode"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                (
                _ctx.criticalPathNode.state !== 'finished' || _ctx.deltaForNode.actualWorkingDays === null
              )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_unref(t)("analytics.critical_path.cycle_times")) + ": ", 1))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.deltaForNode.plannedWorkingDays ?? "-") + " " + _toDisplayString(_unref(t)("working_day.working_day_abbrev")), 1),
              _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(t)("analytics.planner.planned_event_name")), 1)
            ]),
            (_ctx.criticalPathNode.state === 'finished' && _ctx.deltaForNode.actualWorkingDays !== null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(t)("analytics.critical_path.cycle_times")) + ":", 1),
                  _hoisted_22,
                  _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.deltaForNode.actualWorkingDays) + " " + _toDisplayString(_unref(t)("working_day.working_day_abbrev")), 1),
                  _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(t)("analytics.planner.actual_event_name")), 1)
                ]))
              : _createCommentVNode("", true),
            (
            _ctx.criticalPathNode.state === 'finished' &&
            _ctx.deltaForNode.plannedWorkingDays !== null &&
            _ctx.deltaForNode.actualWorkingDays !== null
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _hoisted_26,
                  _hoisted_27,
                  _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.deltaForNode.plannedWorkingDays - _ctx.deltaForNode.actualWorkingDays) + " " + _toDisplayString(_unref(t)("working_day.working_day_abbrev")), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})